import { IPaymentTermsPopupFormState } from '.';
import {
  EnhancedHeaderInputTypes,
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';

export const paymentTermsHeaders: (
  pageState: IPaymentTermsPopupFormState
) => Record<string, EnhancedTableHeader> = (pageState) => {
  const values = pageState.values;
  const customPaymentType = values.paymentType === 'CUSTOM';

  return {
    billNumber: {
      name: 'billNumber',
      title: '#',
      type: EnhancedTableHeaderType.Text,
    },
    ...(customPaymentType
      ? {
          dueDate: {
            name: 'dueDate',
            title: 'Due Date',
            type: EnhancedTableHeaderType.Input,
            inputType: EnhancedHeaderInputTypes.Date,
          },
        }
      : {
          dueDate: {
            name: 'dueDate',
            title: 'Due Date',
            type: EnhancedTableHeaderType.Date,
          },
        }),
    totalPremium: {
      name: 'totalPremium',
      title: 'Total Premium',
      type: EnhancedTableHeaderType.RoundedCurrency,
    },
    ...(customPaymentType
      ? {
          amountDue: {
            name: 'amountDue',
            title: 'Amount Due',
            type: EnhancedTableHeaderType.Input,
            inputType: EnhancedHeaderInputTypes.RoundedCurrency,
            maxDecimalPercision: 3,
            error: pageState.errors.amountDue,
          },
        }
      : {
          amountDue: {
            name: 'amountDue',
            title: 'Amount Due',
            type: EnhancedTableHeaderType.RoundedCurrency,
          },
        }),
    outstandingAmount: {
      name: 'outstandingAmount',
      title: 'Outstanding Amount',
      type: EnhancedTableHeaderType.RoundedCurrency,
    },
    commission: {
      name: 'commission',
      title: 'Commission',
      type: EnhancedTableHeaderType.RoundedCurrency,
    },
    taxOnCommission: {
      name: 'taxOnCommission',
      title: 'Tax On Commission',
      type: EnhancedTableHeaderType.RoundedCurrency,
    },
    status: {
      name: 'status',
      title: 'Status',
      type: EnhancedTableHeaderType.Enum,
    },
  };
};
